export const environment = {
   apiURL: 'https://ipro-api.optimumprocess.com.pl/',
   production: 'true',
};
